/** @jsx jsx */
/** @jsxRuntime classic */

import { Interpolation, jsx } from '@emotion/react';
import React from 'react';
import { TypographyVariant } from '../style/typography';
import useTheme from '../style/useTheme';
import { ThemeConfig } from '../style/theme';

export type TypographyColor = 'default' | 'light' | 'title';

type Props = React.PropsWithChildren<{
  sx?: React.CSSProperties;
  weight?: 'normal' | 'bold';
  align?: 'center' | 'left' | 'right';
  className?: string;
  id?: string;
  ['data-testid']?: string;
  variant?: TypographyVariant;
  color?: TypographyColor;
}>;

const Typography: React.FC<Props> = (props) => {
  const {
    sx,
    weight = 'normal',
    align,
    children,
    color = 'default',
    variant = 'body',
    className,
    id,
    'data-testid': dataTestId,
  } = props;
  const { theme, resolveTypography, resolveColor } = useTheme();

  const css: Interpolation<ThemeConfig> = {
    ...resolveTypography(variant),
    margin: 0,
    textAlign: align,
    color: resolveColor(theme.components.text[color]),
    ...(weight === 'bold' && {
      fontWeight: 700,
    }),
    ...sx,
  };

  return (
    <p data-testid={dataTestId} className={className} id={id} css={css}>
      {children}
    </p>
  );
};

export default Typography;
